export default {
  "--color-primary-50": "255 255 255",
  "--color-primary-100": "238 242 255",
  "--color-primary-200": "243 244 246",
  "--color-primary-300": "247 247 247",
  "--color-primary-400": "51 51 51",
  "--color-primary-500": "0 102 153",
  "--color-primary-600": "245 103 13",
  "--color-primary-700": "255 118 19",
  "--color-secondary-50": "249 250 251",
  "--color-secondary-100": "243 244 246",
  "--color-secondary-200": "229 231 235",
  "--color-secondary-300": "209 213 219",
  "--color-secondary-400": "156 163 175",
  "--color-secondary-500": "107 114 128",
  "--color-secondary-600": "75 85 99",
  "--color-secondary-700": "55 65 81",
  "--color-secondary-800": "31 41 55",
  "--color-secondary-900": "17 24 39",
  "--color-default": "255 255 255",
};
